// extracted by mini-css-extract-plugin
module.exports = {"backButton":"voltarHome_backButton__1z-xm"};